import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserPostsDataService } from '../../../services/posts.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ScoreModalComponent } from '../../../modals/score-modal/score-modal.component';

import *  as Classes from '../../../classes/models.classes'

import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-search-bar',
    templateUrl: './search-bar.component.html',
    styleUrls: ['./search-bar.component.css']
})
export class SearchBarComponent {
    @Input() postData: any;
    @Input() UserID: number;
    @Output() reactionsUpdated = new EventEmitter<any>();

    isDropdownOpen = false;

    searchQuery: string = '';
    searchResults: any[] = [];

    postResults: Classes.SearchResult[] = [];
    userResults: Classes.SearchResult[] = [];

    private searchSubject = new Subject<string>();

    constructor(
        private userPostsDataService: UserPostsDataService,
        private router: Router,
        private modalService: NgbModal
    ) {
        this.searchSubject.pipe(
            debounceTime(300), // wait 300ms after the last event before emitting last event
            distinctUntilChanged(), // only emit if value is different from previous value
            switchMap(query => this.userPostsDataService.search(query))
        ).subscribe(result => {
            this.postResults = result.Posts;
            this.userResults = result.Users;
        });
    }

    onSearch(query: string): void {
        this.userPostsDataService.search(query).subscribe(result => {
            this.postResults = result?.Posts || []; // Default to empty array if undefined
            this.userResults = result?.Users || []; // Default to empty array if undefined
        //    console.log('User Results:', this.userResults); // Debugging log
        });
    }

    onFocusOut(): void {
        setTimeout(() => {
            this.searchResults = []; // Clear results when the search input loses focus
        }, 200);
    }

    // Function to clear the search input
    clearSearch() {
        this.searchQuery = '';
        this.postResults = [];
        this.userResults = [];
    }

    goToSearch(query: string) {
        this.router.navigate(['/search'], { queryParams: { q: query } }); // Navigate to dashboard with query
    }

    goToUser(userName: string) {
        this.router.navigate([`/${userName}`]); // Navigate to user profile
    }


}
